import React, {useState} from 'react';
import { getPublicImagePath, notifySuccess } from '@nutastic/nutastic-react-app';
import AccountValidationForm from "./AccountValidationForm";
import LoginForm from "./LoginForm";
import {ReactSVG} from "react-svg";
import { RegisterPassword } from './RegisterPassword';
import StripePaymentProcessor from '../checkout/StripePaymentProcessor';
import SubscriptionSelector from '../checkout/SubscriptionSelector';

const componentClass = 'loginFlow';

const FLOW_STEPS = {
    VALIDATE: 'VALIDATE',
    LOGIN: 'LOGIN',
    PROMPT: 'PROMPT',
    PASSWORD: 'PASSWORD',
    PICK: 'PICK',
    PAY: 'PAY'
}

export const LoginFlow = ({ onComplete }) => {
    const [currentStep, setCurrentStep] = useState(FLOW_STEPS.VALIDATE);
    const [nuAccountEmail, setNuAccountEmail] = useState('');
    const [nuAccountPassword, setNuAccountPassword] = useState('');
    const [subscriptionOption, setSubscriptionOption] = useState(null);

    const onFlowComplete = () => {
        notifySuccess('Welcome back to the NuStation, we are happy to have you back onboard the spaceship!');
        onComplete && onComplete(nuAccountEmail);
    };

    const renderValidationStep = () => {
        const onValidationComplete = (email, isValid) => {
            setNuAccountEmail(email);
            setCurrentStep(isValid ? FLOW_STEPS.LOGIN : FLOW_STEPS.PROMPT);
        };
        return <AccountValidationForm onValidationComplete={onValidationComplete} emailValue={nuAccountEmail} />;
    };

    const renderLoginStep = () => {
        return <LoginForm
            onLoginComplete={onFlowComplete}
            onCancel={() => setCurrentStep(FLOW_STEPS.VALIDATE)}
            hideEmailField={true}
            emailValue={nuAccountEmail}
        />;
    };

    const renderRegistrationStep = () => {
        const onPasswordEntryComplete = pass => {
            setNuAccountPassword(pass);
            setCurrentStep(FLOW_STEPS.PICK);
        };

        return <RegisterPassword
            onComplete={onPasswordEntryComplete}
            emailToShow={nuAccountEmail}
            onCancel={() => setCurrentStep(FLOW_STEPS.VALIDATE)}
        />;
    };

    const renderSubscriptionPicker = () => {
        const onReadyToPayClicked = subType => {
            setSubscriptionOption(subType);
            setCurrentStep(FLOW_STEPS.PAY);
        };

        return <SubscriptionSelector
            onCancel={() => setCurrentStep(FLOW_STEPS.VALIDATE)}
            onContinue={onReadyToPayClicked}
        />;
    }

    const renderSubscriptionStep = () => {
        const title = "NuStation Account Subscription";
        const description = "Your details have been prepped and you have arrived at the final stage: " +
            "The $pending Step! Once you complete the form below and payment is processed, " +
            "your account setup will be complete and you will be free to fly throughout the NuStation " +
            "to experience more sounds and sights!";
        return <StripePaymentProcessor
            guestEmail={nuAccountEmail}
            products={subscriptionOption}
            title={title}
            description={description}
            isSigningUp={nuAccountPassword}
            onCancel={() => setCurrentStep(FLOW_STEPS.VALIDATE)}
        />;
    };

    const renderPrompt = () => {
        const elementClass = "loginFlowPrompt";
        return <div className={elementClass}>
            <h2>NuStation Account Registration</h2>
            <p>Thanks for coming to the NuStation to spend some love with us. We hope you enjoy your entertainment experience as you explore our Nu World of sounds.
                The email below will used to register your account. Please use a valid email that you have access to, just in case you lose your password.
                Click continue to proceed.</p>
            <div className={`${elementClass}__emailToUse`}><b>Your Account ID / Email Will Be: </b> <span><i>{ nuAccountEmail }</i></span></div>
            <div className={`${elementClass}__buttons nuButtonGroup`}>
                <button className="btn btn-white" onClick={() => setCurrentStep(FLOW_STEPS.VALIDATE)}>
                    <i className="fa fa-arrow-circle-o-left" /> <span>Change Email</span>
                </button>
                <button className="btn btn-primary" onClick={() => setCurrentStep(FLOW_STEPS.PASSWORD)}>
                    <span>Continue</span> <i className="fa fa-arrow-circle-o-right" />
                </button>
            </div>
        </div>
    };

    const renderLoginFlowStep = () => {
        if (currentStep === FLOW_STEPS.VALIDATE) {
            return renderValidationStep();
        } else if (currentStep === FLOW_STEPS.LOGIN) {
            return renderLoginStep();
        } else if (currentStep === FLOW_STEPS.PROMPT) {
            return renderPrompt();
        } else if (currentStep === FLOW_STEPS.PASSWORD) {
            return renderRegistrationStep();
        } else if (currentStep === FLOW_STEPS.PICK) {
            return renderSubscriptionPicker();
        } else if (currentStep === FLOW_STEPS.PAY) {
            return renderSubscriptionStep();
        }
        return null;
    };

    return <div className={componentClass}>
        <ReactSVG src={ getPublicImagePath('nutastic-emblem.svg') } className={`${componentClass}__logo`} />
        <div className={`${componentClass}__wrapper`}>
            { renderLoginFlowStep() }
        </div>
    </div>;
};

export default LoginFlow;
